export default {
    fields: [
        {
            key: "name",
            label: "name",
            sorter: false,
            filter: false,
        },
        {
            key: "value",
            label: "value",
            sorter: false,
            filter: false,
        },
        {
            key: "options",
            label: "options",
            sorter: false,
            filter: false,
            _style: 'width:10%',
        },
    ],
    items: [],
    hover: true,
    border: true,
    striped: true,
    addTableClasses: [
        'table--sm'
    ]
}